import React, { useEffect, useState } from 'react';
import { string, object } from 'prop-types';
import { Link, withRouter } from 'react-router-dom';

import SubInfo, { SubInfoItem, SubInfoItemGroup } from '../SubInfo';
import TopInformation from '../TopInformation';
import Section from '../Section/Section';

import './Version.scss';
import SwitchItem from '../SwitchItem';
import Switch from '../Switch';

import Versions from './Versions';
import BackButton from '../BackButton/BackButton';
import VideoCallButton from '../VideoCallButton/VideoCallButton';
import Skeleton from 'react-loading-skeleton';
import useIsTablet from '../useIsTablet/useIsTablet';
import { Helmet } from 'react-helmet';
import { getDescription, getMeta, getTitle } from '../../utils/helpers';

const Version = ({ match, getVersiones, version }) => {
  const { tipo, modelo } = match.params;

  const [activeIndex, setActiveIndex] = useState(null);
  const [selectedVersion, setSelectedVersion] = useState(null);


  // CORROBORAR QUE EL TIPO Y MODELO NO HAN SIDO CARGADOS
  useEffect(() => {
    const hasVersion = version?.data?.some(
      x => x.modelo.toLowerCase() === modelo.toLowerCase()
    );
    if (hasVersion) return;

    getVersiones(tipo, modelo);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const currentVersion = version?.data?.find(
    x => x.modelo.toLowerCase() === modelo.toLowerCase()
  );


  //Variable booleana para ver si se activa el boton de video llamada o no 
  var videoCallOn = currentVersion?.videoCallOption === "1";

  const versiones = currentVersion?.versiones || {};
  const years = Object.keys(versiones);

  const imageUrl = ([years[activeIndex]] || [])
    .filter(Boolean)
    .reduce((acc, curr, index, array) => {
      return versiones[curr].reduce((acc2, curr2) => {
        return curr2.imagenGrande;
      }, '');
    }, '');

  const dataSource = () => {
    if (!currentVersion?.versiones || !years.length || activeIndex === null)
      return [];

    const year = years[activeIndex];
    return currentVersion?.versiones[year];
  };

  const backButton = (
    <>
      <div className="version-options--back">
        <BackButton to={`/${tipo}/`} />
      </div>
      <hr />
    </>
  );

  const videoCallButton = (
    <>
      <div>
        <VideoCallButton text={'Video llamada'} isSummary={false}/>
      </div>
    </>
  );
  
  const isLoadingV = version.isLoading || (!version.isLoading && version?.data.length === 0);
  const isTablet = useIsTablet();

  const meta = getMeta(modelo);
  const title = getTitle(modelo);
  const description = getDescription(modelo);

  return (
    <div className="version gradient" style={{ '--color': currentVersion?.colorCode }}>
      <Helmet>
        {title && <title>{title}</title>}
        {meta && <meta name="keywords" content={meta} />}
        {description && <meta name="description" content={description} />}
      </Helmet>
      {/* <Subheader
        title="Ármalo a tu manera"
        subtitle="¡Adelante… elegí el que querás y contáctanos !"
      /> */}
      <div className="version__subinfo">
        <SubInfo
          brandUrl={currentVersion?.logoUrl}
          isLoading={version.isLoading}
        >
          <SubInfoItem color="white" type="image">
            {version.isLoading && (
              <Skeleton circle={true} height={50} width={50} />
            )}
            {currentVersion?.logoUrl && !version.isLoading && (
               <Link to={'/'}>
               <img
                src={currentVersion?.logoUrl}
                className="top-information__brand-image"
                alt=""
              />
              </Link>
          )}
          </SubInfoItem>
          <SubInfoItem
            colorCode={currentVersion?.colorCode}
            isLoading={isLoadingV}
          >
            <SubInfoItemGroup
              className="main-title"
              title={currentVersion?.modelo}
            />
          </SubInfoItem>
          {!isTablet && <SubInfoItem color="white" type="image">
          </SubInfoItem>}
        </SubInfo>
      </div>
      <Section>
        <TopInformation
          title="SeleccionÁ"
          subtitle="¿Cuál versión y año es la mejor para vos?"
          brandUrl={currentVersion?.logoUrl}
          isLoading={version.isLoading}
          imageUrl={imageUrl}
          colorCode={currentVersion?.colorCode || 'black'}
          videoCallButton={videoCallButton}
          videoCallOn={videoCallOn}
          isVersionComponent={true}
        />
        <div className="version-years">
          {version.isLoading ? null : (
            <Switch
              onChange={index => {
                setActiveIndex(index);
                setSelectedVersion(null);
              }}
            >
              {years.map(year => (
                <SwitchItem key={year}>{year}</SwitchItem>
              ))}
            </Switch>
          )}
        </div>
        <div className="version-options">
          {/* <p className="version-options--desde">Precios desde</p> */}
          {backButton}
          <Versions
            setSelectedVersion={setSelectedVersion}
            versiones={dataSource()}
            selectedVersion={selectedVersion}
            isLoading={version?.isLoading}
          />
          <div className="mobile">{backButton}</div>
        </div>
      </Section>
    </div>
  );
};

Version.propTypes = {
  modelo: string,
  tipo: string,
  version: object,
};

export default withRouter(Version);
